import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';
import { Field, reduxForm } from 'redux-form';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import Button from 'react-bootstrap/lib/Button';
import FormGroup from 'react-bootstrap/lib/FormGroup';

import InputFieldComponent from '../Common/FormField/InputFieldComponent';

import validate from './validate';
import submit from './submit';
import messages from '../../locale/messages';
import { openForgotPasswordModal } from '../../actions/modalActions';

import s from './Login.css';
import bt from '../../components/commonStyle.css';

const LoginForm = ({ error, handleSubmit, submitting }) => {

  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const siteName = useSelector(state => state.siteSettings.data.siteName);

  const [showPassword, setShowPassword] = useState('');

  const handleChange = (fieldName) => {
    setShowPassword(fieldName == showPassword ? "" : fieldName);
  };

  return (
    <form onSubmit={handleSubmit(submit)}>
      {error && <span className={s.errorMessage}>{formatMessage(error)}</span>}
      <h4 className={s.titleText}>{formatMessage(messages.dashBoardHeader)} {siteName}</h4>
      <FormGroup className={bt.space3}>
        <Field
          name="email"
          type="text"
          component={InputFieldComponent}
          label={formatMessage(messages.email)}
          placeholder={formatMessage(messages.email)}
          inputClass={cx(bt.commonControlInput)}
        />
      </FormGroup>
      <FormGroup className={cx(bt.space3, bt.pwdSection)}>
        <Field
          name="password"
          type="password"
          component={InputFieldComponent}
          label={formatMessage(messages.password)}
          placeholder={formatMessage(messages.password)}
          inputClass={cx("commonPasswordControlInput")}
          showPassword={showPassword}
          isPassword={true}
          onClick={() => handleChange('password')}
        />
        <a onClick={() => dispatch(openForgotPasswordModal())} className={s.modalCaptionLink}>
          <FormattedMessage {...messages.cantLogin} />
        </a>
      </FormGroup>
      <Button className={cx(bt.btnPrimary, bt.btnBig, bt.space4)} block type="submit" disabled={submitting}>
        {formatMessage(messages.login)}
      </Button>
    </form>
  );
}

LoginForm.propTypes = {
  openForgotPasswordModal: PropTypes.func.isRequired,
  formatMessage: PropTypes.func,
  siteName: PropTypes.string.isRequired,
};

export default reduxForm({
  form: 'LoginForm', // a unique name for this form
  validate,
  destroyOnUnmount: false
})(withStyles(s, bt)(LoginForm));